import {
  GET_ALL_DOGS,
  GET_ALL_TEMPS,
  GET_DOGS_BY_NAME,
  RESET_SHOW_DOGS,
  FILTER_DOGS,
  CHANGE_LENGUAGE
} from "../action-types";

const initialState = {
  allDogs: [],
  showAllDogs: [],
  temps: [],
  lenguage:true
};

const reducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case GET_ALL_DOGS:
      return { ...state, allDogs: payload, showAllDogs: payload };
    case GET_ALL_TEMPS:
      return { ...state, temps: payload };
    case GET_DOGS_BY_NAME:
      return { ...state, showAllDogs: payload };
    case FILTER_DOGS:
      return { ...state, showAllDogs: payload };
    case RESET_SHOW_DOGS:
      return { ...state, showAllDogs: state.allDogs };
    case CHANGE_LENGUAGE:
      return { ...state, lenguage: !state.lenguage };
    default:
      return { ...state };
  }
};

export default reducer;
